module.exports = __webpack_public_path__ + "819b06d9405e8479ca2c7c1fb495304b.png";


//////////////////
// WEBPACK FOOTER
// ./src/themes/default/assets/logo_bg.png
// module id = 2861
// module chunks = 0